import { createContext } from "react";
const ButtonNestingContext = createContext(false);
export {
  ButtonNestingContext
};
//# sourceMappingURL=ButtonNestingContext.js.map
